module.exports = __webpack_public_path__ + "static/media/instagram.1fcd7b1c.svg";